import { render } from "./ReserveTicketCancel.vue?vue&type=template&id=0724f96a&scoped=true"
import script from "./ReserveTicketCancel.vue?vue&type=script&lang=js"
export * from "./ReserveTicketCancel.vue?vue&type=script&lang=js"

import "./ReserveTicketCancel.vue?vue&type=style&index=0&id=0724f96a&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0724f96a"]])

export default __exports__